import type { ChipItem } from "app/pages/sales-intelligence/common-components/filters-panel";
import type { RegionGroup } from "app/pages/sales-intelligence/utils/location";
import type { ICountryObject } from "app/services/CountryService";

export enum LocationAssetType {
    Country = "country",
    State = "state",
    Zip = "zip",
    Region = "region",
}

type RegionChipItem = ChipItem & {
    type: LocationAssetType.Region;
    countryIds: readonly number[];
};

type SingleLocationChipItem = ChipItem & {
    type: Exclude<LocationAssetType, LocationAssetType.Region>;
    countryIds?: never;
};

export type LocationChipItem = RegionChipItem | SingleLocationChipItem;

export type LocationDropdownValue = {
    readonly codes?: readonly number[];
    readonly regions?: readonly string[];
};

export type VisibleRegionGroup = {
    group: RegionGroup;
    filteredCountries: readonly ICountryObject[];
    filteredSubGroups: readonly VisibleRegionGroup[];
};
